import { Card } from "@/components/ui/card";

function Row({ label, note, value, valueClass = "", pct, pctClass = "", testId }) {
    return (
        <div className="grid grid-cols-[1fr_auto_auto] items-baseline gap-3 px-2 py-1.5 rounded-md hover:bg-muted/60 transition-colors" data-testid={testId}>
            <span className="text-xs text-muted-foreground truncate">{label}{note && <span className="text-[10px] text-muted-foreground/70"> · {note}</span>}</span>
            <span className={`num text-sm font-semibold ${valueClass}`} data-testid={`${testId}-value`}>{value}</span>
            <span className={`num text-xs font-medium w-14 text-right ${pctClass}`} data-testid={`${testId}-delta`}>{pct || ""}</span>
        </div>
    );
}

/** Headline portfolio figures as a compact 3-column list (same look as Markets). */
export function PortfolioList({ columns }) {
    return (
        <Card className="px-3 py-2.5" data-testid="portfolio-list">
            <div className="px-2 mb-1 text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Portfolio</div>
            <div className="grid grid-cols-1 md:grid-cols-3 md:divide-x divide-border">
                {columns.map((rows, i) => (
                    <div key={i} className="md:px-2 first:md:pl-0 last:md:pr-0" data-testid={`portfolio-col-${i + 1}`}>
                        {rows.filter(Boolean).map((r) => <Row key={r.testId} {...r} />)}
                    </div>
                ))}
            </div>
        </Card>
    );
}
